import { get, update } from "lodash";
import { baseApi } from "..";
import { checkIsAdmin } from "../../../helpers/helpers";

// Define a service using a base URL and expected endpoints
export const prodOrderApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({

    getLibrary: builder.query({
      query: () => `embroidery-library/list`,
      transformResponse: (response) => response.data,
    }),

    getEmbroideryDetails: builder.query({
      query: ({id}) => `embroidery-library/${id}/get`,
      transformResponse: (response) => response.data,
    }),

    GetEmbroideryLibraryList: builder.query({
      query: (organization_id) => `embroidery-library/list-organization/${organization_id}`,
      transformResponse: (response) => response.data,
    }),

    getOrganizationsAllList: builder.query({
      query: () => `organizations/all/list`,
      transformResponse: (response) => response.data,
    }),

    submitEmbroideryDetails: builder.mutation({
      query: ({ data }) => ({
        url: `embroidery-library`,
        method: "POST",
        body: {
          data,
        },
      }),

      transformResponse: (response) => response.data,
    }),

    uploadEmbroideryImage: builder.mutation({
      query: ({ data }) => ({
        url: `file/embroidery`,
        method: "POST",
        body: data,
        formData: true,
      }),

      transformResponse: (response) => response.data,
    }),

    updateEmbroideryDetails: builder.mutation({
      query: ({ id, data }) => ({
        url: `embroidery-library/${id}`,
        method: "PUT",
        body: {
          data,
        },
      }),
      transformResponse: (response) => response.data,
    }),

    deleteEmbroideryDetails: builder.mutation({
      query: ({ id }) => ({
        url: `embroidery-library/${id}`,
        method: "DELETE",
      }),
      transformResponse: (response) => response.data,
    }),

   
  }),
  overrideExisting: false,
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetLibraryQuery,
  useGetEmbroideryDetailsQuery,
  useSubmitEmbroideryDetailsMutation,
  useDeleteEmbroideryDetailsMutation,
  useGetOrganizationsAllListQuery,
  useUploadEmbroideryImageMutation,
  useUpdateEmbroideryDetailsMutation,
  useGetEmbroideryLibraryListQuery,
} = prodOrderApi;